import { render, staticRenderFns } from "./CommCdLangTable.vue?vue&type=template&id=5cd4367c&"
import script from "./CommCdLangTable.vue?vue&type=script&lang=js&"
export * from "./CommCdLangTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports